import React from 'react';
import { ApolloClient, HttpLink, InMemoryCache, ApolloProvider, DocumentNode, FieldPolicy, FieldReadFunction } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';

interface IGraphQLProvider {
    connection: string;
    credentials?: 'include' | '';
    typeDefs?: string | string[] | DocumentNode | DocumentNode[];

    // For fields in Query
    fields?: IFields;

    // For item fields
    itemFields?: IItemFields;
}

export interface IItemFields {
    [fieldName: string]: {
        fields: { [fieldName: string]: IFields };
    };
}

export interface IFields {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [fieldName: string]: FieldPolicy<any> | FieldReadFunction<any>;
}

export const GraphQLContext: React.FC<IGraphQLProvider> = ({ fields, itemFields, typeDefs, children, connection, credentials = '' }) => {
    const client = new ApolloClient({
        link: new HttpLink({
            uri: connection,
            credentials,
        }),
        cache: new InMemoryCache({
            typePolicies: {
                Query: {
                    fields: {
                        nodes: offsetLimitPagination(),
                        ...fields,
                    },
                },
                ...itemFields,
                DirectoryConnection: {
                    fields: {
                        totalSelectedCount: {
                            merge(_, incoming) {
                                return incoming;
                            },
                        },
                    },
                },
                Entry: {
                    keyFields: ['entryID'],
                },
                DateInfo: {
                    keyFields: ['js'],
                },
                CurrencyInfo: {
                    keyFields: ['value'],
                },
            },
        }),
        typeDefs,
    });

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
